export default "__VITE_ASSET__FiA2WPJ4__"